export default "__VITE_ASSET__DaY$aUwP__"